import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { noop, Subject } from 'rxjs';
import { takeUntil, take, catchError } from 'rxjs/operators';

import { SessionWarningModalComponent } from '@global/shared-features/modals/session-warning-modal/session-warning-modal.component';

import { SessionService } from '@global/services/session/session.service';
import { ModalService } from 'dlg-walrus';

import { MainActions } from '../state/actions';

import { environment } from '@env/environment';
import { ERRORS_SESSION_TIMEOUT } from '@app/infrastructure/constants';
import { PostNavigationService } from '@global/services/post-navigation/post-navigation.service';

@Component({
  selector: 'app-main-container',
  templateUrl: './main-container.component.html',
})
export class MainContainerComponent implements OnInit, OnDestroy {
  active: Array<number> = [];
  keepTrackingApp$: Subject<boolean> = new Subject<boolean>();
  cookieUrl = environment.brand_copy.cookieUrl;

  constructor(
    private readonly router: Router,
    private readonly store: Store<{}>,
    private readonly sessionService: SessionService,
    private readonly modalService: ModalService,
    private readonly postNavigationService: PostNavigationService,
    private readonly renderer: Renderer2
  ) {
    postNavigationService.renderer = this.renderer;
  }

  ngOnInit() {
    this.postNavigationService
      .onNavigate()
      .pipe(takeUntil(this.keepTrackingApp$))
      .subscribe(noop);
    this.sessionService.getSessionExpirySeconds$.subscribe((session) =>
      this.openSessionExpiryModal(session)
    );
  }

  ngOnDestroy() {
    this.keepTrackingApp$.next(false);
    this.keepTrackingApp$.unsubscribe();
  }

  private openSessionExpiryModal(session) {
    if (this.router.url !== ERRORS_SESSION_TIMEOUT) {
      const expirySeconds = session.secondsRemaining;
      if (expirySeconds > 0) {
        this.modalService
          .open(SessionWarningModalComponent, { expirySeconds })
          .closed$.subscribe((result) => {
            if (result === 'exit') {
              this.store.dispatch(MainActions.redirectToMyAccountDashboard());
            } else if (result === 'timeout') {
              this.router.navigate([ERRORS_SESSION_TIMEOUT]);
            } else {
              this.sessionService
                .refreshSession(session.sessionId)
                .pipe(
                  take(1),
                  catchError(() =>
                    this.router.navigate([ERRORS_SESSION_TIMEOUT])
                  )
                )
                .subscribe(() => this.ngOnInit());
            }
          });
      } else {
        this.router.navigate([ERRORS_SESSION_TIMEOUT]);
      }
    }
  }
}
